/**
 * Created by joellee on 6/2/16.
 */
commonModule.factory('erateService', ['AppSettings', 'commonRESTCallService','$q',
    function (AppSettings, commonRESTCallService, $q) {
        var erateService = {};

        erateService.getSpanDealership = function (spanId) {
            var deferred = $q.defer();
            var url = AppSettings.startSPANPlusSvcURL + 'spandealers/' + spanId;
            commonRESTCallService.getFromServer(url)
                .success(function(responseData, status) {
                    deferred.resolve(responseData.itemList ? responseData.itemList[0] : responseData);
                })
                .error(function(responseData, status) {
                    deferred.reject(responseData);
                });
            return deferred.promise;
        }

    return erateService;
}]);